import script from "./deleteDataCollectionUrl.vue?vue&type=script&setup=true&lang=js"
export * from "./deleteDataCollectionUrl.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__